module.exports = __webpack_public_path__ + "static/media/off-camera.726ee7f5.png";